import { useState } from "react";
import { useDecimalInput } from "../../../hooks/useDecimalInput";
import { PRECISION } from "../../../precision";
import axios from "axios";
import socket from "../../../socket/socket";

const UpdateWallet = ({
  id,
  type,
  setType,
  setAlertConfig,
  fetchMerchantDetails,
}) => {
  const [transactionNote, setTransactionNote] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState({});

  const { input: amount, bind: bindForm, reset: resetForm } = useDecimalInput();

  const token = localStorage.getItem("token");

  const resetModal = () => {
    resetForm();
    setTransactionNote("");
    setError({});
    setType(null);
  };

  const isValidInput = () => {
    if (amount === "") return false;

    const n = Number(amount);
    return Number.isFinite(n) && n > 0;
  };

  const updateWalletBalance = async () => {
    const amountNum = Number(amount);

    if (!Number.isFinite(amountNum) || amountNum <= 0) {
      setError({
        ...error,
        amount: "Please enter a valid amount",
      });
      return;
    }

    const amountFormatted = Number(amountNum.toFixed(PRECISION));

    setIsSubmitting(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}${
          type === "topup" ? "topup-wallet" : "deduct-wallet"
        }`,
        {
          amount: amountFormatted,
          merchantId: id,
          notes: transactionNote?.trim()
            ? transactionNote
            : type === "topup"
            ? "Topup Wallet Balance"
            : "Deduct Wallet Balance",
          type: type === "topup" ? "credit" : "debit",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res?.data?.code === 1) {
        socket.emit("merchant:dataUpdate", { merchantId: id });
        resetModal();
        setAlertConfig({
          show: true,
          message: res.data.message,
          type: "success",
        });
        fetchMerchantDetails();
      } else {
        setError({ ...error, amount: res?.data?.message });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className={type?.trim() ? "modal fade show d-block" : "modal fade"}>
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          {/* Modal Header */}
          <div className="modal-header text-center">
            <h5 className="modal-title mx-auto">
              {`${type === "topup" ? "TOPUP" : "DEDUCT"}`} WALLET BALANCE
            </h5>

            {/* Close (X) */}
            <button
              type="button"
              className="btn-close position-absolute end-0 me-3"
              onClick={resetModal}
            />
          </div>

          {/* Modal Body */}
          <div className="modal-body p-4">
            <div className="row">
              <div className="col-md-12 mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter amount"
                  autoComplete="off"
                  {...bindForm}
                />

                {error.amount && (
                  <small className="text-danger mt-2">{error.amount}</small>
                )}
              </div>

              <div className="col-md-12">
                <textarea
                  className="form-control"
                  placeholder="Note (Optional)"
                  autoComplete="off"
                  value={transactionNote}
                  onChange={(e) => setTransactionNote(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Modal Footer */}
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn btn-sm btn-secondary me-3"
              onClick={resetModal}
            >
              Close
            </button>

            <button
              onClick={updateWalletBalance}
              type="button"
              className={`btn btn-${
                type === "topup" ? "success" : "danger"
              } btn-sm`}
              disabled={!isValidInput() || isSubmitting}
            >
              {isSubmitting ? (
                <span className="spinner-border spinner-border-sm me-2" />
              ) : null}
              <span className="indicator-label">
                {isSubmitting
                  ? "Processing..."
                  : type === "topup"
                  ? "Topup"
                  : "Deduct"}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateWallet;
